import { connect } from 'react-redux'
import moment from 'moment'
import { getInstanceSettings } from 'app/selectors'
import { DonorRollDataGrid } from '../components/DonorRollDataGrid'
import * as donorRollSelectors from '../selectors'
import { actions } from '../actions'
import { Dispatch } from 'redux'

export interface StateToProps {
    donorRollSettings?: DonorRollSettingsDto
    overrideDisplayLimit: boolean
    data?: ApiDonorRollDataRecord[]
    controlId: number
}

export interface DataGridStateToProps {
    donorAvatarStyle?: React.CSSProperties
    donorRollSettings?: DonorRollSettingsDto
    displayEndDateTime?: moment.Moment | string
    displayStartDateTime?: moment.Moment
    dataGridEvenStyle?: React.CSSProperties
    dataGridOddStyle?: React.CSSProperties
    titleOptions?: TitleOptions
    overrideDisplayDate?: boolean
    data?: ApiDonorRollDataRecord[]
    showModule: boolean
    subTitleStyle?: React.CSSProperties
    titleStyle?: React.CSSProperties
    showSubTitle: boolean
    showTitle: boolean
    anonymousDonorVerbiage: string
    anonymousAmountVerbiage: string
    designationVerbiage: string
    includeDesignation: boolean | undefined
}

export interface DispatchToProps {
    toggleOverrideDisplayLimit: () => void
}

export const mapStateToProps = (state: RootState): StateToProps & DataGridStateToProps => {
    const dataGridEvenStyle = donorRollSelectors.getDataGridEvenOptions(state)
    const dataGridOddStyle = donorRollSelectors.getDataGridOddOptions(state)
    const donorAvatarStyle = donorRollSelectors.getDonorAvatarStyles(state)
    const donorRollSettings = getInstanceSettings(state) as DonorRollSettingsDto | undefined
    const showModule = imod.cms.scoreboards.overrideDisplayDate || donorRollSelectors.getShowModule(state)
    const titleStyle = donorRollSelectors.getTitleTextStyle(state) as React.CSSProperties
    const subTitleStyle = donorRollSelectors.getSubTitleTextStyle(state) as React.CSSProperties
    const overrideDisplayLimit = donorRollSelectors.getDonorRollOverrideDisplayLimit(state) || false
    const anonymousDonorVerbiage = donorRollSelectors.getAnonymousDonorVerbiage(state)
    const anonymousAmountVerbiage = donorRollSelectors.getAnonymousAmountVerbiage(state)
    const designationVerbiage = donorRollSelectors.getDesignationVerbiage(state)

    return {
        data: state.donorRoll!.data,
        controlId: state.config.controlId,
        donorAvatarStyle,
        donorRollSettings,
        showModule,
        showSubTitle: Boolean(donorRollSettings && donorRollSettings.moduleSubTitle && subTitleStyle && showModule),
        showTitle: Boolean(titleStyle && showModule),
        subTitleStyle,
        titleStyle,
        dataGridEvenStyle,
        dataGridOddStyle,
        overrideDisplayLimit,
        anonymousDonorVerbiage: anonymousDonorVerbiage ? anonymousDonorVerbiage : 'Anonymous',
        anonymousAmountVerbiage: anonymousAmountVerbiage ? anonymousAmountVerbiage : 'anonymous',
        designationVerbiage: designationVerbiage ? designationVerbiage : 'to the',
        includeDesignation: donorRollSelectors.getIncludeDesignation(state),
    }
}
export const mapDispatchToProps = (dispatch: Dispatch) => ({
    toggleOverrideDisplayLimit: () => {
        dispatch(actions.toggleDonorRollOverrideDisplayLimit())
    },
})

export const DonorRoll = connect(mapStateToProps, mapDispatchToProps)(DonorRollDataGrid)
